import { api } from "./api";
import type { CreateCustomerData } from "./customer.service";

export type UserRole = "ADMIN" | "MANAGER" | "ORDER_CLERK" | "DRIVER";

export interface User {
  id: string;
  email: string;
  firstName: string | null;
  lastName: string | null;
  phone: string | null;
  role: UserRole;
  isActive: boolean;
  customerId?: string | null;
  customer?: {
    id: string;
    firstName: string | null;
    lastName: string;
  } | null;
  createdAt: string;
  updatedAt: string;
}

/** Payload POST /api/users (création par admin) */
export interface CreateUserPayload {
  email: string;
  password: string;
  role: UserRole;
  firstName?: string | null;
  lastName?: string | null;
  phoneDialCode?: string;
  phone?: string | null;
  customerId?: string | null;
  newCustomer?: CreateCustomerData;
}

/**
 * Service pour la gestion des utilisateurs (liste, détail)
 */
export const userService = {
  async getAll(includeInactive = false, search?: string): Promise<User[]> {
    const params: Record<string, string> = {
      includeInactive: includeInactive ? "true" : "false",
    };
    if (search?.trim()) params.search = search.trim();

    const response = await api.get<{ success: boolean; data: User[] }>("/users", {
      params,
    });
    return response.data.data;
  },

  async getById(id: string): Promise<User> {
    const response = await api.get<{ success: boolean; data: User }>(
      `/users/${id}`
    );
    return response.data.data;
  },

  async create(data: CreateUserPayload): Promise<User> {
    const response = await api.post<{ success: boolean; data: User }>(
      "/users",
      data
    );
    return response.data.data;
  },
};
